import fetch from '@/utils/fetch';
import { uploadByFileIdParams } from './type';

const model = {
  state: {},
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: () => ({
    // 获取列表-线下成本
    async getCashbackRecord(params) {
      const list = await fetch('/datahub/crm/management/import/getImportInfoByPage', {
        type: 'GET',
        params,
      });
      return list || [];
    },

    // 获取列表-综合运营成本
    async getOperatingCostByPage(params) {
      const list = await fetch('/datahub/crm/management/import/getComprehensiveIncomeByPage', {
        type: 'GET',
        params,
      });
      return list || [];
    },

    // 获取列表-线下收入
    async getOrderCommissionByPage(params) {
      const list = await fetch('/datahub/crm/management/import/getOrderCommissionByPage', {
        type: 'GET',
        params,
      });
      return list || [];
    },
    // 获取禁选日期
    async getAllDateRange(params) {
      const list = await fetch('/datahub/crm/management/import/getAllDateRange', {
        type: 'GET',
        params,
      });
      return list || [];
    },
    // 获取上传日志
    async getTaskResult(taskId: number) {
      const list = await fetch('/datahub/crm/management/import/getTaskResult', {
        params: {
          taskId,
        },
      });
      return list || [];
    },
    // 获取上传状态
    async getTaskStatus(taskId: number) {
      return fetch('/datahub/crm/management/import/getTaskStatus', {
        params: {
          taskId,
        },
      });
    },
    // 确认导入
    async uploadSure(params: uploadByFileIdParams) {
      const detail = await fetch('/datahub/crm/management/import/upload', {
        type: 'POST',
        params,
        useJson: true,
      });
      return detail;
    },
    // 弃用
    async discard(taskId, fileType) {
      const detail = await fetch('/datahub/crm/management/import/discard', {
        type: 'POST',
        params: {
          taskId,
          fileType,
        },
        useJson: true,
      });
      return detail;
    },
  }),
};

export default model;
